/* eslint-disable no-unused-vars */

export enum BatchType {
  BATCH = "BATCH",
  COURSE = "COURSE",
}

export enum ActivityActionType {
  UPDATE = "UPDATE",
  READ = "READ",
  CREATE = "CREATE",
  DELETE = "DELETE",
  DOWNLOAD = "DOWNLOAD",
  UPLOAD = "UPLOAD",
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  REQUEST = "REQUEST",
}

export enum UserType {
  ADMIN = "admin",
  STUDENT = "student",
}

export enum AppModule {
  AUTH = "AUTH",
  DASHBOARD = "DASHBOARD",
  BATCH = "BATCH",
  COURSE = "COURSE",
  CHAT = "CHAT",
  STUDENT = "STUDENT",
  PAYMENT = "PAYMENT",
  FULFILMENT = "FULFILMENT",
  REQUEST = "REQUEST",
  BIRTHDAY = "BIRTHDAY",
  INVENTORY = "INVENTORY",
  MEMBER = "MEMBER",
  PERMISSION = "PERMISSION",
  CATEGORY = "CATEGORY",
  CATEGORY_TYPE = "CATEGORY_TYPE",
  ACTIVITY = "ACTIVITY",
  ANNOUNCEMENT = "ANNOUNCEMENT",
  ATTENDANCE = "ATTENDANCE",
  TEST = "TEST",
  PERFORMANCE = "PERFORMANCE",
  QUESTION = "QUESTION",
  ARTICLE = "ARTICLE",
  ANALYTICS = "ANALYTICS",
  LANDING = "LANDING",
}

export enum ClassStatus {
  STARTED = "STARTED",
  ENDED = "ENDED",
  NOT_STARTED = "NOT_STARTED",
}

export enum ContentCategory {
  STUDY_MATERIAL = "STUDY_MATERIAL",
}

export enum ContentType {
  FOLDER = "FOLDER",
  FILE = "FILE",
}

export enum ContentFileType {
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
}

export enum Fulfilment {
  UNFULFILLED = "UNFULFILLED",
  MANIFESTED = "MANIFESTED",
  ORDER_CREATED = "ORDER_CREATED",
  FULFILLED = "FULFILLED",
}

export enum RequestStatus {
  OPEN = "OPEN",
  PROCESSING = "PROCESSING",
  RESOLVED = "RESOLVED",
  CLOSED = "CLOSED",
}

export enum UserRole {
  SUPER_ADMIN = "SUPER_ADMIN",
  MANAGER = "MANAGER",
  TEACHER = "TEACHER",
  STUDENT = "STUDENT",
  AUTHOR = "AUTHOR",
}

export enum CategoryType {
  STUDENT = "STUDENT",
  BATCH = "BATCH",
  REQUEST = "REQUEST",
  ARTICLE = "ARTICLE",
  LANGUAGES = "LANGUAGES",
  CLASSIFICATION = "CLASSIFICATION",
}

export enum DifficultyLevel {
  EASY = "EASY",
  MEDIUM = "MEDIUM",
  HARD = "HARD",
}

export enum TestStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  PUBLISHED = "PUBLISHED",
  COMPLETED = "COMPLETED",
  UPCOMING = "UPCOMING",
  ASSIGNED = "ASSIGNED",
  ONGOING = "ONGOING",
}

export enum TagType {
  QUESTION = "QUESTION",
  ARTICLE = "ARTICLE",
  STUDENT = "STUDENT",
  TEST = "TEST",
}

export enum SubjectType {
  QUESTION = "QUESTION",
  ARTICLE = "ARTICLE",
}

export enum ArticleStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  TRASH = "TRASH",
}

// export type PaymentPurpose = "Admission Fee" | "Module Fee" | "Postal Fee" | "Others";
export enum PaymentPurpose {
  ADMISSION_FEE = "Admission Fee",
  MODULE_FEE = "Module Fee",
  POSTAL_FEE = "Postal Fee",
  COURSE_FEE = "Course Fee",
  CART_CHECKOUT = "Cart Checkout",
  OTHERS = "Others",
}

export enum CoursePaymentType {
  ONE_TIME = "ONE_TIME",
  RECURRING = "RECURRING",
}

export enum PaymentStatus {
  DUE = "due",
  PAID = "paid",
  REFUNDED = "refunded",
}

export enum InvoiceType {
  GENERAL = "GENERAL",
  COURSE = "COURSE",
}
